import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderFilterFacesModal = (data = {}) => openPopupHelper({ popupName: popupNames.MOBILE_FILTER_FACES, data });
